import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

import ChartStatCard from '../components/ChartStatCard.jsx';
import DecimalValueFormat from '../components/DecimalValueFormat.jsx';
import AboveBelowFormat from '../components/AboveBelowFormat.jsx';
import TimeSeriesLineChart from '../components/TimeSeriesLineChart.jsx';

import { FLOOD_LEVEL_MARKERS } from '../helpers/SiteDataConst.js';
import { getSiteData, getSiteDataSourcesForTypes, getSiteLastData, getSiteState } from '../helpers/SiteData.js';

function RiverSiteBlock({site, allData, colSize}) {
  const {t} = useTranslation();
  const data = getSiteData(allData, site.id, site.types[0]);
  const dataSource = getSiteDataSourcesForTypes(site, [site.types[0]]);
  const state = getSiteState(allData, site.id);
  const lastData = getSiteLastData(allData,  site.id, site.types[0]);

  return (
    <Col {...colSize} key={site.id} id={site.id} className={'mb-4'}>
      <h3>{site.name}</h3>
      <ChartStatCard
        title="Water Level"
        noData={lastData?.value === undefined}
        stat={lastData?.value ? DecimalValueFormat({value: lastData?.value}) : undefined}
        secondStat={site.properties?.benchmarks?.[0] && lastData?.value ? AboveBelowFormat({
          value: lastData?.value,
          unit: t(`units.${site.properties.unit}.label`),
          benchmark: site.properties.benchmarks[0]
        }) : undefined}
        time={lastData?.timestamp}
        unit={t(`units.${site.properties.unit}.label`)}
        status={state?.siteState}
        dataSource={dataSource}
      >
        <TimeSeriesLineChart
          data={data != undefined ? [data] : undefined}
          dataSeries={[site.types[0]]}
          title={site.name}
          unit={t(`units.${site.properties.unit}.label`)}
          minDate={DateTime.now().minus({days: 3}).toJSDate()}
          maxDate={DateTime.now().toJSDate()}
          markers={SiteChartMarkers(t, site, t(`units.${site.properties.unit}.label`))}
        />
      </ChartStatCard>
    </Col>
  );
}

function SiteChartMarkers(t, site= {}, unit) {
  let markers = [];

  if (site.properties?.benchmarks) {
    const chartBenchmarks = site.properties.benchmarks.filter((benchmark) => benchmark.displayOnChart);
    const benchmarkMarkers = chartBenchmarks.map((benchmark) => {
      return {
        axis: 'y',
        value: benchmark.value,
        lineStyle: {
          stroke: '#42708C',
          strokeWidth: 1,
        },
        textStyle: {
          fill: '#42708C',
          fontSize: 10,
        },
        legend: `${benchmark.name} - ${benchmark.value} ${unit}`,
        legendPosition: 'top-right',
        legendOffsetY: 8,
        legendOffsetX: 2,
      };
    });
    markers = markers.concat(benchmarkMarkers)
  }

  if (site.properties?.floodLevels) {
    const floodLevelMarkers = site.properties.floodLevels.map((floodLevel) => {
      const floodLevelLabel = t(`floodLevels.${floodLevel.type}.label`);
      return {
        axis: 'y',
        value: floodLevel.value,
        lineStyle: {
          stroke: FLOOD_LEVEL_MARKERS[floodLevel.type]?.color,
          strokeWidth: 1,
        },
        textStyle: {
          fill: FLOOD_LEVEL_MARKERS[floodLevel.type]?.color,
          fontSize: 10,
        },
        legend: `${floodLevelLabel} ${t('floodLevels.suffix')} - ${floodLevel.value} ${unit}`,
        legendPosition: 'top-left',
        legendOffsetY: 8,
        legendOffsetX: 2,
      };
    });

    markers = markers.concat(floodLevelMarkers);
  }

  return markers
}

export default RiverSiteBlock
